export default "__VITE_ASSET__3021474d__"